import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { CoreModule } from 'src/app/components/core/core.module';
import { AforoRoutingModule } from './aforos-routing.module';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AforoFilterComponent } from './aforo-filter/aforo-filter.component';
import { AforoEditComponent } from './aforo-edit/aforo-edit.component';
import { AforoListComponent } from './aforo-list/aforo-list.component';
import { AforoWrapperEditComponent } from './aforo-wrapper-edit/aforo-wrapper-edit.component';
import { AforoWrapperComponent } from './aforo-wrapper/aforo-wrapper.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AppModuleGlobalShared } from 'src/app/app.module.global';
import { CultivoModule } from '../../../_campanias/cultivos/cultivo.module';

@NgModule({
    declarations: [AforoWrapperComponent, AforoListComponent, AforoFilterComponent, AforoEditComponent, AforoWrapperEditComponent],
    imports: [
        CultivoModule,
        ProgressSpinnerModule,
        NgbModule,
        SelectButtonModule,
        NgSelectModule,
        TableModule,
        PaginatorModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AforoRoutingModule,
        CoreModule,
        AppModuleGlobalShared, // PipeSiNo
    ],
    providers: [ExceptionManager],
})
export class AforosModule {}
